import React, { useState } from "react";

import VisibilitySensor from "react-visibility-sensor";
import { useTranslation } from "react-i18next";

import img1 from "../../../assets/img/fleetStructure/fleetTwo/fleetTwoImg.webp";

function FleetTwo() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  const onChange = (visibility) => {
    if (visibility) {
      setIsVisible(true);
    }
  };

  return (
    <VisibilitySensor onChange={onChange} partialVisibility minTopValue={500}>
      <div className="fleetTwo">
        <div className="fleetTwoContent">
          <div className="fleetTwoTitle">
            <h1 className={`${isVisible ? "visible" : ""}`}>
              {t("fleet_two_title")}
            </h1>
          </div>
          <div className="fleetTwoText">
            <div className="text1 text">
              <h3 className={`${isVisible ? "visible" : ""}`}>{t("fleet_two_horse_avg")}</h3>
              <p className={`${isVisible ? "visible" : ""}`}>
                {t("fleet_two_horse_label")}
              </p>
            </div>
            <div className="text2 text">
              <h3 className={`${isVisible ? "visible" : ""}`}>{t("fleet_two_trailer_avg")}</h3>
              <p className={`${isVisible ? "visible" : ""}`}>
                {t("fleet_two_trailer_label")}
              </p>
            </div>
            <p className={`${isVisible ? "visible" : ""}`}>
              {t("fleet_two_text")}
            </p>
          </div>
        </div>
        <div className={`fleetTwoImg ${isVisible ? "visible" : ""}`}>
          <img src={img1} alt="caminhão azul da GH" width={"900px"} />
        </div>
      </div>
    </VisibilitySensor>
  );
}
export default FleetTwo;
